import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {BillingParty} from '../../../graphql/billing_party.datatypes';
import {gqlBillingParty} from '../../BillingParty/getBillingParty.api';


export interface CancelGroupMembersInBillingPartyInput {
    id: number
    cancel: boolean
}

interface CancelGroupMembersInBillingPartyData {
    __typename?: string,
    cancelGroupMembersInBillingParty: BillingParty
}

export const CANCEL_GROUP_MEMBER_MUTATION = gql`
    mutation cancelGroupMembersInBillingParty($id: Int! $cancel: Boolean!) {
        cancelGroupMembersInBillingParty(id: $id, cancel: $cancel) {
            ${gqlBillingParty}
        }
    }
`;

export const cancelGroupMembersInBillingParty = () => useMutation<CancelGroupMembersInBillingPartyData, CancelGroupMembersInBillingPartyInput>(
    CANCEL_GROUP_MEMBER_MUTATION,
    {
        update: updateCacheByType('BillingParty'),
    }
);

export default cancelGroupMembersInBillingParty;